// extracted by mini-css-extract-plugin
module.exports = {"dividerSmall":"AppAdmin_dividerSmall__1s680"};